import { Component, Input, ViewChild } from '@angular/core';

import { NceService } from './../../nce/services/nce.service';
import { NceAdminService } from './../../nce-admin/services/nce-admin.service';
import { PageNavigationService } from './../../shared/services/page-navigation.service';
import { LayoutService } from './../../shared/services/layout.service';
import { StorageService } from './../../shared/services/storage.service';
import { FileService } from './../../shared/services/file.service';
import { ErrorService } from './../../shared/services/error.service';
import { PopupService } from './../../shared/services/pop-up.service';

import { CONFIGURATION } from './../../shared/configuration/configuration';
import { STATIC_VALUE } from './../../shared/configuration/static.value';

@Component({
    selector: 'edit-preview-child',
    templateUrl: 'edit-preview-child.component.html',
})
export class EditPreviewChildComponent{

    vExpandStatus = [false, false, false, false, false, false, false, false, false];
    currFile: number;
    isEditMode: boolean = false;
    remarks: string = '';
    cancelationRemarks: string = '';
    vMinDurationTo = new Date();
    vMinEstimatedCompletion = new Date();
    vMinContractDate = new Date();
    vMHNumber: string  = '';
    vContractPrincipal:string;

    @Input()
    nceid: string = "";

    @ViewChild('fileInput') vFileInput;
    @ViewChild('fileInputAppointment') vFileAppointment;
    @ViewChild('fileInputCancellation') vFileCancellation;

    vShow = {
        btn_back: false,
        btn_home: false,
        btn_payment: false,
        btn_briefing_session: false,
        btn_make_appointment: false,
        btn_approve: false,
        btn_cancel_nce: false,
        btn_reject: false,
        btn_waiting_diversion: false,
        btn_change_appointment: false,
        contractor_details: false,
        upload_document: false,
        briefing_session: false,
        appointment: false,
        reject: false,
        diversion: false,
        approval: false,
        btn_upload_appointment_upload: false,
        payment: false,
        cancelled_attachment: false
    }

    vLoadingShow: boolean = false;
    
    vAppointmentData = {
        updated_date: new Date(),
        appointment_date: new Date(),
        appointment_time: '',
        appointment_description: '',
        appointment_type: '',
        popup_title: ''
    }

    vDummyDetailNCE = {
        nce_record_id: '',
        nce_request_id: '',
        nce_reference_id: '',
        prev_request_id:'',
        plant_record_id: '',
        plant_request_id: '',
        supervisor_name: '',
        supervisor_nric: '',
        supervisor_tel: '',
        supervisor_mobile: '',
        contract_principal: '',
        contract_officer: '',
        contract_tel: '',
        contract_mobile: '',
        contract_start: '',
        contract_end: '',
        contract_no: '',
        contract_work_order: '',
        contract_contact_person: '',
        contract_contact_number: '',
        contract_company_name: '',
        tcdw_name: '',
        tcdw_nric: '',
        tcdw_tel: '',
        tcdw_mobile: '',
        tcdw_license: '',
        tcdw_expiry_date: '',
        contractor_company_address: '',
        contractor_company_name: '',
        contractor_company_reg_no: '',
        contractor_first_name: '',
        contractor_last_name: '',
        contractor_telephone_no: '',
        contractor_designation: '',
        contractor_email: '',
        contractor_mobile_no: '',
        contractor_contact_person: '',
        contractor_postal_code: '',
        supervisor_company_name: '',
        status: '',
        status_description:'',
        location_earthwork: '',
        duration_from_date: '',
        duration_to_date: '',
        pipe_affected: '',
        distance_work_area: '',
        nature_proposed_earthwork: '',
        depth_earthwork: '',
        actual_start_date: '',
        estimate_end_date: '',
        work_under_s29: -1,
        already_start: -1,
        earthwork_remark: [],
        manholes_number: [],
        attachment: {
            sketch: '',
            schedule: '',
            support: '',
            briefing: [],
            appointment: [],
            waiting_for_diversion: [],
            rejected: [],
            approval: [],
            plantmap: [],
            cancellation: []
        },
        declare_name: '',
        declare_job_title: '',
        declare_phone_number: '',
        term_conditions: -1,
        appointment_date: '',
        appointment_time: '',
        appointment_description: '',
        first_name: '',
        last_name: '',
        company_name: '',
        phone_no: '',
        address_line_1: '',
        company_reg_no: '',
    }

    remark_1 = false;
    remark_2 = false;
    remark_3 = false;
    remark_4 = false;
    remark_5 = false;
    remark_5_value: '';

    vShowAttachment = false;

    constructor(
        private _nceService: NceService,
        private _nceAdminService: NceAdminService,
        private _layoutService: LayoutService,
        private _pageNavigationService: PageNavigationService,
        private _storageService: StorageService,
        private _fileService: FileService,
        private _errorService: ErrorService,
        private _popupService: PopupService
    ) { }

    getExpandStatus(){
        return this.vExpandStatus
    }

    getAllEarthworkRemarks(){
        return STATIC_VALUE.NCE_EARTHWORK_REMARKS;
    }

    ngOnInit() {
        this._layoutService.setCurrentPage('admin-edit-preview');
        this._nceService.resetError();
        this.pushDataDummy().then((response) => {
            this.vMinDurationTo = new Date(this.getDummyNCE().duration_from_date);
            this.vMinDurationTo.setDate(this.vMinDurationTo.getDate() + 1);
            this.vMinEstimatedCompletion = new Date(this.getDummyNCE().actual_start_date);
            this.vMinEstimatedCompletion.setDate(this.vMinEstimatedCompletion.getDate() + 1);

            let totalRemark = this.vDummyDetailNCE.earthwork_remark !== undefined ? this.vDummyDetailNCE.earthwork_remark.length : 0;
            if(this.vDummyDetailNCE.earthwork_remark.some(x => x === STATIC_VALUE.NCE_EARTHWORK_REMARKS[0])) {
                this.remark_1  = true;
                totalRemark--;
            } else {
                this.remark_1  = false;
            }
            if(this.vDummyDetailNCE.earthwork_remark.some(x => x === STATIC_VALUE.NCE_EARTHWORK_REMARKS[1])) {
                this.remark_2  = true;
                totalRemark--;
            } else {
                this.remark_2  = false;
            }
            if(this.vDummyDetailNCE.earthwork_remark.some(x => x === STATIC_VALUE.NCE_EARTHWORK_REMARKS[2])) {
                this.remark_3  = true;
                totalRemark--;
            } else {
                this.remark_3  = false;
            }
            if(this.vDummyDetailNCE.earthwork_remark.some(x => x === STATIC_VALUE.NCE_EARTHWORK_REMARKS[3])) {
                this.remark_4  = true;
                totalRemark--;
            } else {
                this.remark_4  = false;
            }
            if(totalRemark > 0) {
                this.remark_5_value = this.vDummyDetailNCE.earthwork_remark[this.vDummyDetailNCE.earthwork_remark.length - 1];
                this.remark_5  = true;
            } else {
                this.remark_5_value = '';
                this.remark_5  = false;
            }
            let ext_indicator = this.vDummyDetailNCE.nce_request_id.substring(this.vDummyDetailNCE.nce_request_id.indexOf("-")+1, this.vDummyDetailNCE.nce_request_id.length)
            if(parseInt(ext_indicator) > 1)
                this._storageService.setSessionItem('extensionNCE', '1');
            this.setCurrentFlow();
            this.vShowAttachment = true;

            if( this.vDummyDetailNCE.contract_principal === STATIC_VALUE.NCE_CONTRACT_PRINCIPALS[0] || 
                this.vDummyDetailNCE.contract_principal === STATIC_VALUE.NCE_CONTRACT_PRINCIPALS[1] ||
                this.vDummyDetailNCE.contract_principal === STATIC_VALUE.NCE_CONTRACT_PRINCIPALS[2] 
            ){
                this.vContractPrincipal = this.getDummyNCE().contract_principal;
            }else{
                this.vContractPrincipal = 'Other Agencies & Pte'
            }
        })
    }

    setCurrentFlow(){
        if(this._nceService.vDetailNCE.status_description === STATIC_VALUE.ALL_NCE_STATUS.PAYMENT_IN_PROGRESS ||
            this._nceService.vDetailNCE.status_description === STATIC_VALUE.ALL_NCE_STATUS.PAYMENT_FAILED || 
            this._nceService.vDetailNCE.status_description === STATIC_VALUE.ALL_NCE_STATUS.PAYMENT_PENDING){
            this._layoutService.setNCEFlow('nce-payment');
        } else if(this._nceService.vDetailNCE.status_description === STATIC_VALUE.ALL_NCE_STATUS.PENDING_BRIEFING_SCHEDULE || 
            this._nceService.vDetailNCE.status_description === STATIC_VALUE.ALL_NCE_STATUS.PENDING_PROVISIONING){
            this._layoutService.setNCEFlow('nce-briefing-session');
        } else if(this._nceService.vDetailNCE.status_description === STATIC_VALUE.ALL_NCE_STATUS.PENDING_TRIAL_HOLE_INSPECTION ||
            this._nceService.vDetailNCE.status_description === STATIC_VALUE.ALL_NCE_STATUS.PENDING_APPOINTMENT_SCHEDULE){
            this._layoutService.setNCEFlow('nce-make-appointment');
        } else if(this._nceService.vDetailNCE.status_description === STATIC_VALUE.ALL_NCE_STATUS.PENDING_BRIEFING_DOCUMENT ||
            this._nceService.vDetailNCE.status_description === STATIC_VALUE.ALL_NCE_STATUS.REJECTED_BRIEFING_DOCUMENT){
            this._layoutService.setNCEFlow('nce-briefing-document');
        } else if(this._nceService.vDetailNCE.status_description === STATIC_VALUE.ALL_NCE_STATUS.PENDING_APPOINTMENT_DOCUMENT ||
            this._nceService.vDetailNCE.status_description === STATIC_VALUE.ALL_NCE_STATUS.REJECTED_APPOINTMENT_DOCUMENT){
            this._layoutService.setNCEFlow('nce-appointment-document');
        } else if(this._nceService.vDetailNCE.status_description === STATIC_VALUE.ALL_NCE_STATUS.APPOINTMENT_DOCUMENT_UPLOAD){
            this._layoutService.setNCEFlow('nce-appointment-upload');
        } else if(
                this._nceService.vDetailNCE.status_description === STATIC_VALUE.ALL_NCE_STATUS.PENDING_FINAL||
                this._nceService.vDetailNCE.status_description === STATIC_VALUE.ALL_NCE_STATUS.REJECTED||
                this._nceService.vDetailNCE.status_description === STATIC_VALUE.ALL_NCE_STATUS.WAIT_DIVERSION||
                this._nceService.vDetailNCE.status_description === STATIC_VALUE.ALL_NCE_STATUS.APPROVED || 
                this._nceService.vDetailNCE.status_description === STATIC_VALUE.ALL_NCE_STATUS.EXPIRED ||
                this._nceService.vDetailNCE.status_description === STATIC_VALUE.ALL_NCE_STATUS.CANCELLED){
                this._layoutService.setNCEFlow('nce-final-approval');
        }
    }

    getDummyNCE(){
        return this.vDummyDetailNCE;
    }

    pushDataDummy(){
        return new Promise((resolve, reject) => {
            this.vDummyDetailNCE = this.getDetailNCE();
            resolve()
        })
    }

    getErrorStatusAndMessage(){
        return this._errorService.getErrorStatusAndMessage();
    }

    getMultipleFilesList(){
        return this._fileService.getMultipleFilesList();
    }

    getNceAttachment(){
        return this.getDummyNCE().attachment;
    }

    isAbleDeleteFile(pIndex: number){
        return (this.getFileList()[pIndex] !== '' && this.getFileList()[pIndex] !== undefined && this.getFileList()[pIndex] !== null);
    }

    removeMultipleAttachment(pIndex){
        if(this.getNceAttachment().plantmap.length <= 1){
            this._popupService.openGeneralConfirmationPopup('Error', 'NCE Application required at least 1 attachment', '', false, false);
        }else{
            this._fileService.deleteFiles(this.getDummyNCE().nce_request_id, 'nce', 'plantmap' , this.getNceAttachment().plantmap[pIndex]).then(
                (resolve) => {
                    this.getNceAttachment().plantmap.splice(pIndex, 1)
                    this._storageService.setSessionItem('nceMultipleFiles', JSON.stringify(this._fileService.getMultipleFilesList()));
                }, 
                (reject) => {
                    this._popupService.openGeneralConfirmationPopup('Error', 'Delete file unsuccessful, please try again', '', false, false);
                }
            );
        }
    }

    removeAppointmentAttachment(pIndex, pFileName){
        if(this.getNceAttachment().appointment.length <= 1){
            this._popupService.openGeneralConfirmationPopup('Error', 'NCE Application required at least 1 attachment', '', false, false);
        }else{
            this._fileService.deleteFiles(this.getDummyNCE().nce_request_id, 'nce', 'appointment' , this.getNceAttachment().appointment[pIndex]).then(
                (resolve) => {
                    this.getNceAttachment().appointment.splice(pIndex, 1)
                    this._storageService.setSessionItem('nceMultipleFiles', JSON.stringify(this._fileService.getMultipleFilesList()));
                }, 
                (reject) => {
                    this._popupService.openGeneralConfirmationPopup('Error', 'Delete file unsuccessful, please try again', '', false, false);
                }
            );
        }
        // this.currFile = pIndex;
        // this._fileService.deleteFiles(this.getDetailNCE().nce_request_id, 'nce', 'appointment' , pFileName).then(
        //     (resolve) => {
        //         this.getNceAttachment().appointment.splice(pIndex, 1);
        //         this._popupService.openGeneralConfirmationPopup('Notice', 'File successfully deleted', '', false, false);
        //         this._storageService.setSessionItem('nceFiles', JSON.stringify(this._fileService.getFileLists()));
        //     },
        //     (reject) => {
        //         this._popupService.openGeneralConfirmationPopup('Notice', 'Error delete file, please try again', '', false, false);
        //     }
        // );
    }

    fileEventMultiple(fileInput: any, pType){
        let file = fileInput.target.files[0];
        if(file === undefined){
            return;
        }
        if(file.size > CONFIGURATION.FILE.MAX_SIZE || (file.type !== "image/jpeg" && file.type !== "application/pdf")) {
            this._popupService.openGeneralConfirmationPopup('Notice', 'Attached file type must be PDF or JPEG file only and up to 10MB', '', false, false);
            return;
        }

        if(this.getNceAttachment().plantmap !== undefined){
            if(this.getNceAttachment().plantmap.some(x => x === file.name)){
                this._popupService.openGeneralConfirmationPopup('Notice', 'Please provide file with another name', '', false, false);
                return;
            }
            this.getNceAttachment().plantmap.push(file.name);
            this._fileService.uploadMultipleFile(file, 'nce', pType, this.getDummyNCE().nce_request_id, this.getDummyNCE().nce_record_id);
            
        }else{
            this._fileService.uploadMultipleFile(file, 'nce', pType, this.getDummyNCE().nce_request_id, this.getDummyNCE().nce_record_id);
        }
    }

    fileEventAppointment(fileInputAppointment: any){
        let file = fileInputAppointment.target.files[0];
        if(file === undefined){
            return;
        }
        if(file.size > CONFIGURATION.FILE.MAX_SIZE || (file.type !== "image/jpeg" && file.type !== "application/pdf")) {
            this._popupService.openGeneralConfirmationPopup('Notice', 'Attached file type must be PDF or JPEG file only and up to 10MB', '', false, false);
            return;
        }
        if(this.getNceAttachment().appointment !== undefined){
            if(this.getNceAttachment().appointment.some(x => x === file.name)){
                this._popupService.openGeneralConfirmationPopup('Notice', 'Please provide file with another name', '', false, false);
                return;
            }
            this.getNceAttachment().appointment.push(file.name);
            this._fileService.uploadMultipleFile(file, 'nce', 'appointment', this.getDummyNCE().nce_request_id, this.getDummyNCE().nce_record_id);
            this.vFileAppointment.nativeElement.value = "";
        }else{
            this._fileService.uploadMultipleFile(file, 'nce', 'appointment', this.getDummyNCE().nce_request_id, this.getDummyNCE().nce_record_id);
        }
    }

    fileEventUpload(fileInput: any, type: string){
        let file = fileInput.target.files[0];
        if(file.size > CONFIGURATION.FILE.MAX_SIZE || (file.type !== "image/jpeg" && file.type !== "application/pdf")) {
            this._popupService.openGeneralConfirmationPopup('Error', 'Attached file type must be PDF or JPEG file only and up to 10MB', '', false, false);
        }
        else if(file !== undefined){
            if(type === 'sketch'){
                this.overwriteFile(file, type, 0);
            } else if (type === 'schedule'){
                this.overwriteFile(file, type, 1);
            } else if (type === 'support'){
                this.overwriteFile(file, type, 2);
            }
        }
    }

    overwriteFile(file, type, pIndex){
        if(this.getNceAttachment()[type] !== undefined && this.getNceAttachment()[type] !== '' && this.getNceAttachment()[type] !== null){
            let prevFileName = this.getNceAttachment()[type];
            this._fileService.deleteFiles(this.getDetailNCE().nce_request_id, 'nce', type , prevFileName).then(
                (resolve) => {
                    this.getNceAttachment()[type] = file.name;
                    this._fileService.uploadMultipleFile(file, 'nce', type, this.getDetailNCE().nce_request_id, this.getDetailNCE().nce_record_id);
                },
                (reject) => {
                    this._popupService.openGeneralConfirmationPopup('Error', 'Upload unsuccessful, please try again', '', false, false);
                    this.getNceAttachment()[type] = prevFileName;
                }
            );
        }else{
            this.getNceAttachment()[type] = file.name;
            this._fileService.uploadMultipleFile(file, 'nce', type, this.getDetailNCE().nce_request_id, this.getDetailNCE().nce_record_id);
        }
    }

    fileEventCancellation(fileInputAppointment: any){
        let file = fileInputAppointment.target.files[0];
        if(file === undefined){
            return;
        }
        if(file.size > CONFIGURATION.FILE.MAX_SIZE || (file.type !== "image/jpeg" && file.type !== "application/pdf")) {
            this._popupService.openGeneralConfirmationPopup('Notice', 'Attached file type must be PDF or JPEG file only and up to 10MB', '', false, false);
            return;
        }
        if(this.getNceAttachment().appointment !== undefined){
            if(this.getNceAttachment().appointment.some(x => x === file.name)){
                this._popupService.openGeneralConfirmationPopup('Notice', 'Please provide file with another name', '', false, false);
                return;
            }
            this.getNceAttachment().appointment.push(file.name);
            this._fileService.getSignedRequest(file, 'nce', 'appointment', this.getDetailNCE().nce_request_id, this.getDetailNCE().nce_record_id);
            this.vFileAppointment.nativeElement.value = "";
        }else{
            this._fileService.getSignedRequest(file, 'nce', 'appointment', this.getDetailNCE().nce_request_id, this.getDetailNCE().nce_record_id);
        }
    }

    editMode(){
        this.isEditMode = true;
    }

    resetShowState(){
        this.vShow = {
            btn_back: false,
            btn_home: false,
            btn_payment: false,
            btn_briefing_session: false,
            btn_make_appointment: false,
            btn_approve: false,
            btn_reject: false,
            btn_waiting_diversion: false,
            btn_change_appointment: false,
            btn_cancel_nce: false,
            contractor_details: false,
            upload_document: false,
            briefing_session: false,
            appointment: false,
            reject: false,
            diversion: false,
            approval: false,
            btn_upload_appointment_upload: false,
            payment: false,
            cancelled_attachment: false
        }
    }

    getDetailNCE(){
        return this._nceService.vDetailNCE;
    }

    getFileList(){
        return this._fileService.getFileLists();
    }

    isLoading(){
        return this._nceService.isLoading() || this._nceAdminService.isLoading() || this._fileService.isLoading();
    }

    isShowState(){
        let access;
        this.resetShowState();
        try{
            access = JSON.parse(this._storageService.getLocalItem('access'));
        }catch(e){
            access = null;
        }
        this.vShow.contractor_details = true;
        if (this.getDetailNCE().status_description === STATIC_VALUE.ALL_NCE_STATUS.PENDING_PROVISIONING ||
            this.getDetailNCE().status_description === STATIC_VALUE.ALL_NCE_STATUS.PENDING_APPOINTMENT_SCHEDULE || 
            this.getDetailNCE().status_description === STATIC_VALUE.ALL_NCE_STATUS.PENDING_APPOINTMENT_DOCUMENT ||
            this.getDetailNCE().status_description === STATIC_VALUE.ALL_NCE_STATUS.APPOINTMENT_DOCUMENT_UPLOAD){
            this.vShow.briefing_session = true;
        } else if(this.getDetailNCE().status_description === STATIC_VALUE.ALL_NCE_STATUS.PENDING_TRIAL_HOLE_INSPECTION){
            this.vShow.briefing_session = true;
            this.vShow.appointment = true;
        } else if(this.getDetailNCE().status_description === STATIC_VALUE.ALL_NCE_STATUS.REJECTED){
            this.vShow.briefing_session = true;
            this.vShow.appointment = true;
            this.vShow.reject = true;
            if(this.getDetailNCE().attachment.waiting_for_diversion !== undefined){
                this.vShow.diversion = true;
            }
        } else if(this.getDetailNCE().status_description === STATIC_VALUE.ALL_NCE_STATUS.WAIT_DIVERSION){
            this.vShow.briefing_session = true;
            this.vShow.appointment = true;
            this.vShow.diversion = true;
        } else if(this.getDetailNCE().status_description === STATIC_VALUE.ALL_NCE_STATUS.APPROVED){
            this.vShow.briefing_session = true;
            this.vShow.appointment = true;
            this.vShow.approval = true;
            if(this.getDetailNCE().attachment.waiting_for_diversion !== undefined){
                this.vShow.diversion = true;
            }
        } else if(this.getDetailNCE().status_description === STATIC_VALUE.ALL_NCE_STATUS.CANCELLED){
            this.vShow.cancelled_attachment = true;
        }
        if(this.actionChecking('APPNCE', access)){ // NCEA
            this.vShow.btn_back = true;
            this.vShow.btn_cancel_nce = true;
            if (this.getDetailNCE().status_description === STATIC_VALUE.ALL_NCE_STATUS.CANCELLED ||
                this.getDetailNCE().status_description == STATIC_VALUE.ALL_NCE_STATUS.APPROVED ||
                this.getDetailNCE().status_description == STATIC_VALUE.ALL_NCE_STATUS.EXPIRED            
            ){
                this.vShow.btn_cancel_nce = false;
            }
            if (this.getDetailNCE().status_description === STATIC_VALUE.ALL_NCE_STATUS.PENDING_PROVISIONING){
                this.vShow.btn_approve = true;
                this.vShow.btn_change_appointment = true;
                this.vShow.upload_document = true;
                this.vShow.payment = true;
            } else if (this.getDetailNCE().status_description === STATIC_VALUE.ALL_NCE_STATUS.PENDING_TRIAL_HOLE_INSPECTION){
                this.vShow.btn_approve = true;
                this.vShow.btn_reject = true;
                this.vShow.btn_waiting_diversion = true;
                this.vShow.btn_change_appointment = true;
                this.vShow.upload_document = true;
                this.vShow.payment = true;
            }else if (this.getDetailNCE().status_description === STATIC_VALUE.ALL_NCE_STATUS.WAIT_DIVERSION){
                this.vShow.btn_approve = true;
                this.vShow.btn_reject = true;
                this.vShow.upload_document = true;
                this.vShow.payment = true;
            } else if (this.getDetailNCE().status_description === STATIC_VALUE.ALL_NCE_STATUS.PENDING_BRIEFING_DOCUMENT){
                this.vShow.btn_approve = true;
                this.vShow.btn_reject = true;
                this.vShow.payment = true;
            }else if (this.getDetailNCE().status_description === STATIC_VALUE.ALL_NCE_STATUS.PENDING_APPOINTMENT_DOCUMENT){
                this.vShow.btn_approve = true;
                this.vShow.btn_reject = true;
                this.vShow.payment = true;
            } else if (this.getDetailNCE().status_description === STATIC_VALUE.ALL_NCE_STATUS.APPROVED ||
                this.getDetailNCE().status_description === STATIC_VALUE.ALL_NCE_STATUS.REJECTED ||
                this.getDetailNCE().status_description === STATIC_VALUE.ALL_NCE_STATUS.REJECTED_BRIEFING_DOCUMENT ||
                this.getDetailNCE().status_description === STATIC_VALUE.ALL_NCE_STATUS.REJECTED_APPOINTMENT_DOCUMENT ||
                this.getDetailNCE().status_description === STATIC_VALUE.ALL_NCE_STATUS.EXPIRED ||
                this.getDetailNCE().status_description === STATIC_VALUE.ALL_NCE_STATUS.APPOINTMENT_DOCUMENT_UPLOAD ||
                this.getDetailNCE().status_description === STATIC_VALUE.ALL_NCE_STATUS.PENDING_APPOINTMENT_SCHEDULE ||
                this.getDetailNCE().status_description === STATIC_VALUE.ALL_NCE_STATUS.PENDING_BRIEFING_SCHEDULE
            ) {
                this.vShow.payment = true;
            }

        } else if(this.actionChecking('MANNCE', access)){ // NCE Ops
            this.vShow.btn_back = true;
        } else if(this.actionChecking('PURNCE', access)){ // Customer
            if(this.getDetailNCE().status_description === 'NCE_XX'){
                // this.vShow.contractor_details = false;
                this.vShow.btn_back = true;
                this.vShow.btn_payment = true;
            } else if(this._layoutService.getCurrentPage() === 'nce-view'){
                this.vShow.btn_back = true;
                if (this.getDetailNCE().status_description === STATIC_VALUE.ALL_NCE_STATUS.PENDING_BRIEFING_SCHEDULE){
                    this.vShow.btn_briefing_session = true;
                } else if (this.getDetailNCE().status_description === STATIC_VALUE.ALL_NCE_STATUS.PENDING_APPOINTMENT_SCHEDULE ){
                    this.vShow.btn_make_appointment = true;
                } else if(this.getDetailNCE().status_description === STATIC_VALUE.ALL_NCE_STATUS.APPOINTMENT_DOCUMENT_UPLOAD){
                    this.vShow.btn_upload_appointment_upload = true;
                }
            } else if(this._layoutService.getCurrentPage() === 'nce-final-approval' && this.getDetailNCE().status_description === STATIC_VALUE.ALL_NCE_STATUS.APPROVED){
                this.vShow.btn_home = true;
            } else if(this._layoutService.getCurrentPage() === 'nce-briefing-document'){
                this.vShow.btn_back = true;
            }
        }
        return this.vShow;
    }

    isShowEditButton(){
        let access;
        this.resetShowState();
        try{
            access = JSON.parse(this._storageService.getLocalItem('access'));
        }catch(e){
            access = null;
        }
        if(this.actionChecking('PURNCE', access)){ 
            if(
                // this.getDetailNCE().status_description == this.getAllNCEStatus().PENDING_BRIEFING_DOCUMENT || 
                // this.getDetailNCE().status_description == this.getAllNCEStatus().PENDING_APPOINTMENT_DOCUMENT  ||
                this.getDetailNCE().status_description == this.getAllNCEStatus().REJECTED_BRIEFING_DOCUMENT ||
                this.getDetailNCE().status_description == this.getAllNCEStatus().REJECTED_APPOINTMENT_DOCUMENT
            ){
                return true
            }else{
                return false
            }
        }else{
            return false
        }
    }

    actionChecking(type, accesses) {
        for(var access of accesses){
            if(access == type){
                return true;
            }
        }
        return false;
    }

    getAllNCEStatus(){
        return STATIC_VALUE.ALL_NCE_STATUS;
    }

    doneEditing(){
        if(this.getDummyNCE().supervisor_nric.length != 4){
            this._errorService.setErrorFlag(true);
            this._errorService.setErrorStatusAndMessage('spvNric', 'Supervisor NRIC should be only last 4 digits');
        }
        else if(this.getDummyNCE().tcdw_nric.length != 4){
            this._errorService.setErrorFlag(true);
            this._errorService.setErrorStatusAndMessage('tcdwNric', 'TCDW NRIC should be only last 4 digits');
        }
        else {
            if(!/^\d{3}[A-Z]$/.test(this.getDummyNCE().supervisor_nric.toUpperCase())){
                this._errorService.setErrorFlag(true);
                this._errorService.setErrorStatusAndMessage('spvNric', 'Supervisor NRIC must be contain 3 number and 1 alphabets');
            }else if(!/^\d{3}[A-Z]$/.test(this.getDummyNCE().tcdw_nric.toUpperCase())){
                this._errorService.setErrorFlag(true);
                this._errorService.setErrorStatusAndMessage('tcdwNric', 'TCDW NRIC must be contain 3 number and 1 alphabets');
            }else{
                this._nceService.editNce(this.getDummyNCE()).then(
                    (resolve) => {
                       this.goBack();
                    },
                    (reject) => {
                    }
                );
            }
        }        
    }

    goBack(){
        let vLink;
        vLink = [ '/nce-application/request/' + this.vDummyDetailNCE.nce_record_id ];
        this._pageNavigationService.navigate(vLink);
    }

    goHome(){
        let vLink = ['home'];
        this._pageNavigationService.navigate(vLink);
    }

    goToPayment(){
        let vLink = ['nce-application/payment'];
        this._pageNavigationService.navigate(vLink);
    }

    downloadFile(file:string,attachType) {
        this.vLoadingShow = true;
        this._fileService.getSignedDownloadRequest(file,'nce',attachType,this.getDetailNCE().prev_request_id);
    }

    getNatureOfProposedRemark(){
        if(this.getDetailNCE().earthwork_remark !== undefined || this.getDetailNCE().nature_proposed_earthwork !== undefined){
            let text = this.getDetailNCE().earthwork_remark + ', ' + this.getDetailNCE().nature_proposed_earthwork;
            return text
        }
    }

    setMinDurationTo(pSelectedDate){
        this.vMinDurationTo = new Date(pSelectedDate);
        this.vMinDurationTo.setDate(this.vMinDurationTo.getDate() + 1);
        let vDurationTo = new Date(this.getDummyNCE().duration_to_date);
        if(pSelectedDate.getTime() >= vDurationTo.getTime()){
            this.getDummyNCE().duration_to_date = '';
        }
    }

    setMinEstimatedCompletion(pSelectedDate){
        this.vMinEstimatedCompletion = new Date(pSelectedDate);
        this.vMinEstimatedCompletion.setDate(this.vMinEstimatedCompletion.getDate() + 1);
        let vEstimateEnd = new Date(this.getDummyNCE().estimate_end_date);
        if(pSelectedDate.getTime() >= vEstimateEnd.getTime()){
            this.getDummyNCE().estimate_end_date = '';
        }
    }

    setMinContractEnd(pSelectedDate){
        this.vMinContractDate = new Date(pSelectedDate);
        this.vMinContractDate.setDate(this.vMinContractDate.getDate() + 1);
        let vContractEnd = new Date(this.getDummyNCE().contract_end);
        if(pSelectedDate.getTime() >= vContractEnd.getTime()){
            this.getDummyNCE().contract_end = '';
        }
    }

    addMHNumber() {
        this._nceService.resetError();
        if(!this.validateMHNumber()) {
            return;
        }
        this.getDummyNCE().manholes_number.push(this.vMHNumber);
        this.vMHNumber = '';
    }

    removeMHNumber(pIndex: number) {
        this.getDummyNCE().manholes_number.splice(pIndex, 1);
    }

    validateMHNumber() {
        if(!/^MH-[0-9]+$/.test(this.vMHNumber)){
            this._errorService.setErrorFlag(true);
            this._errorService.setErrorStatusAndMessage('manholeNumber', 'Manhole Number must be MH-number');
            return false;
        } else if(this.getDummyNCE().manholes_number.indexOf(this.vMHNumber) > -1) {
            this._errorService.setErrorFlag(true);
            this._errorService.setErrorStatusAndMessage('manholeNumber', 'This manhole number has been added');
            return false;
        }
        return true;
    }

    vContractPrincipalChange() {
        if(this.vContractPrincipal !== 'Other Agencies & Pte'){
            this.getDummyNCE().contract_principal = this.vContractPrincipal;
        } else {
            this.vContractPrincipal = 'Other Agencies & Pte';
        }
    }

    getPrincipalsValue(){
        return STATIC_VALUE.NCE_CONTRACT_PRINCIPALS;
    }

}


// WEBPACK FOOTER //
// /home/maheshreddy/PRP_FE/src/app/admin/components/edit-preview-child.component.ts